import { useEffect, useState } from "react";
import useAppSettingsService from "../../hooks/useAppSettingsService";
import { MaintenanceModeContext } from "./MaintenanceModeContext";

interface MaintenanceModeProviderProps {
  children: React.ReactNode;
}

const MaintenanceModeProvider = ({
  children,
}: MaintenanceModeProviderProps) => {
  const appSettingsService = useAppSettingsService();
  const [isMaintenance, setIsMaintenance] = useState<boolean | undefined>(
    undefined,
  );

  useEffect(() => {
    appSettingsService.getLatestSettings().then((settings) => {
      if (settings) {
        setIsMaintenance(settings.isMaintenance);
      }
    });
  }, [appSettingsService]);

  return (
    <MaintenanceModeContext.Provider
      value={{ isMaintenance, setIsMaintenance }}
    >
      {children}
    </MaintenanceModeContext.Provider>
  );
};

export default MaintenanceModeProvider;
